import { Link } from "react-router-dom";
import { CalendarPlus } from "lucide-react";
import { formatDateTime } from "../lib/utils";

function formatDeadline(value) {
  const raw = String(value || "").trim();
  if (!raw) return "-";
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const [year, month, day] = raw.split("-").map(Number);
    return new Intl.DateTimeFormat("id-ID", {
      day: "numeric",
      month: "long",
      year: "numeric",
      timeZone: "Asia/Jakarta",
    }).format(new Date(Date.UTC(year, month - 1, day)));
  }
  const parsed = new Date(raw);
  if (!Number.isNaN(parsed.getTime())) return formatDateTime(raw);
  return raw;
}

function noticePath(item) {
  if (item.role_view === "admin") return "/admin/campaigns";
  if (item.role_view === "brand" || item.role_view === "client") return "/client";
  return item.campaign_id ? `/campaigns/${item.campaign_id}` : "/campaigns";
}

export function ExtensionNoticeCard({ item, compact = false, onSeen }) {
  return (
    <div className={`rounded-lg border-2 border-[#0A0A0A] bg-white ${compact ? "p-2.5" : "p-3"}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-1 text-xs font-black uppercase opacity-60">
            <CalendarPlus size={13}/> Campaign diperpanjang
          </div>
          <div className="font-display font-bold truncate mt-1">{item.title || "Campaign"}</div>
          <div className="text-xs text-[#4A4A4A] truncate">{item.brand_name || "-"} · {formatDateTime(item.extended_at)}</div>
        </div>
        <div className="max-w-[9rem] shrink-0 text-right">
          <div className="text-[10px] uppercase font-black opacity-60">Deadline baru</div>
          <div className="font-display font-black text-sm">{formatDeadline(item.deadline)}</div>
        </div>
      </div>
      {!compact && (
        <div className="mt-2 rounded-md border-2 border-[#0A0A0A] bg-[#FDFBF7] p-2 text-xs">
          <div className="font-black">Semua approved link lanjut dari views terakhir.</div>
          {item.extension_note && <div className="mt-1 text-[#4A4A4A]">{item.extension_note}</div>}
        </div>
      )}
      <div className="mt-3 flex flex-wrap gap-2">
        <Link to={noticePath(item)} onClick={onSeen} className="nb-btn nb-btn-secondary text-xs px-3 py-2">
          Lihat Campaign
        </Link>
        {onSeen && (
          <button type="button" onClick={onSeen} className="nb-btn text-xs px-3 py-2">
            Sudah Dilihat
          </button>
        )}
      </div>
    </div>
  );
}

export default function CampaignExtensionNoticePanel({ items, onSeen, title = "Campaign diperpanjang", className = "" }) {
  if (!items?.length) return null;
  return (
    <section className={`nb-card-flat bg-[#FFD600] p-3 sm:p-4 ${className}`} data-testid="campaign-extension-alert">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <span className="nb-pill bg-white">Extend Campaign</span>
          <h2 className="font-display font-black text-lg sm:text-xl mt-2">{title}</h2>
          <p className="text-sm text-[#4A4A4A] mt-1">Campaign aktif lagi. Approved link lama lanjut dari views terakhir, bukan mulai dari nol.</p>
        </div>
        <button type="button" onClick={() => onSeen?.(items)} className="nb-btn text-xs px-3 py-2">
          Tandai Semua Dilihat
        </button>
      </div>
      <div className="mt-3 grid lg:grid-cols-2 gap-3">
        {items.map((item) => (
          <ExtensionNoticeCard key={item.notification_key || item.id} item={item} onSeen={() => onSeen?.([item])} />
        ))}
      </div>
    </section>
  );
}
